import React, {PropsWithChildren} from 'react';
import {Control, Controller} from 'react-hook-form';
import {RadioGroup} from '@mui/material';

interface ControllerRadioGroupWrapperProps {
  name: string;
  defaultValue: any;
  control?: Control<any>;

  className?: any;
  row?: boolean;
}

export const ControllerRadioGroupWrapper = ({
                                              name, defaultValue, control, className, children, row
                                            }: PropsWithChildren<ControllerRadioGroupWrapperProps>) => (!control ?
    <RadioGroup
        className={className}
        row={row}
    >
      {children}
    </RadioGroup> : <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({field}) => <RadioGroup
            className={className}
            row={row}
            {...field}
        >
          {children}
        </RadioGroup>}/>)